module.exports = __webpack_public_path__ + "img/auto.0bcd1b53.png";